module.exports = __webpack_public_path__ + "static/media/acoustic-antique-art-290660.ff3a05cc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/static/acoustic-antique-art-290660.jpg
// module id = 298
// module chunks = 0